import { render, staticRenderFns } from "./MaterialIconSelector.vue?vue&type=template&id=6c42abcb&scoped=true&"
import script from "./MaterialIconSelector.vue?vue&type=script&lang=ts&"
export * from "./MaterialIconSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42abcb",
  null
  
)

export default component.exports